import { IArtistMutationForm } from 'services/artists/types';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { IMusicProductPhysicalForm } from 'services/music-product-physical/types/form';
import { ITrackMutationForm } from 'services/tracks/types';
import { IVideoMutationForm } from 'services/video/types';
import { StateCreator } from 'zustand';

interface IFormState {
  musicProductPhysicalForm: IMusicProductPhysicalForm | null;
  musicProductDigitalForm: IMusicProductDigitalForm | null;
  trackForm: ITrackMutationForm | null;
  videoForm: IVideoMutationForm | null;
  artistForm: IArtistMutationForm | null;
}

interface IFormActions {
  clearForms: () => void;
  clearForm: (form: keyof IFormState) => void;
  setForm: <Form extends keyof IFormState>(form: Form, values: IFormState[Form]) => void;
}

export interface IFormStore extends IFormState, IFormActions {}

export const formSliceInitialValues: IFormState = {
  musicProductPhysicalForm: null,
  musicProductDigitalForm: null,
  trackForm: null,
  videoForm: null,
  artistForm: null,
};

export const createFormSlice: StateCreator<IFormStore> = (set) => ({
  ...formSliceInitialValues,
  setForm: (form, value) => set({ [form]: value }),
  clearForm: (form) => set({ [form]: null }),
  clearForms: () => set({ ...formSliceInitialValues }),
});
